import { useTranslate, FunctionField, BooleanField } from "react-admin";
import CustomList from "./CustomList";
import ListDotsActions from "./ListDotsActions";
import { Link } from "react-router-dom";
import { Avatar, ListItemButton, Theme, useMediaQuery } from "@mui/material";
import CustomDataGrid from "./CustomDataGrid";
import { EmptyStaffIcon } from "assets/Icons";
import { CustomButton } from "./CustomButton";
import CustomSearch from "./CustomSearch";

export default function ArtistList() {
  const translate = useTranslate();
  const isSmall = useMediaQuery<Theme>("(max-width:800px)");

  return (
    <CustomList
      resource="CustomArtist"
      filters={[
        <CustomSearch label={translate("users.search")} source="q" alwaysOn />
      ]}
      title={translate("pagenames.staff")}
      emptyIcon={<EmptyStaffIcon />}
      emptyTitle={translate("empty_list.no_staff_members_yet")}
      createButtonText={translate("empty_list.add_a_member")}
      emptyListCreateSubtitle={translate("empty_list.do_you_want_to_add_one")}
      createResource="Artist"
    >
      <CustomDataGrid
        bulkActionButtons={false}
        rowClick={(id: string, resource: any, record: any) =>
          record?.artist?.id
            ? `/dashboard/Artist/${record?.artist?.id}/show`
            : `/dashboard/Customer/${id}/show`
        }
      >
        <FunctionField
          label={translate("artists.technicians")}
          data-label={translate("artists.technicians") + ":"}
          sx={{ marginTop: "6px" }}
          render={(record: any) => (
            <div
              className="max-w-fit"
              onClick={(e) => e.stopPropagation()}
              aria-hidden
            >
              <Link
                to={
                  record?.artist?.id
                    ? `/dashboard/Artist/${record?.artist?.id}/show`
                    : `/dashboard/Customer/${record?.id}/show`
                }
                className="flex items-center gap-[16px]"
              >
                <Avatar
                  sx={{
                    bgcolor: "rgba(238, 234, 228, 0.9)",
                    color: "rgba(48, 47, 46, 0.95)",
                    width: "32px",
                    height: "32px",
                    fontFamily: "Inter",
                    fontSize: "18px",
                    "@media screen and (max-width:800px)": {
                      width: "24px",
                      height: "24px"
                    }
                  }}
                  alt={record?.first_name}
                  src={
                    record?.artist?.cover_photo_url ||
                    record?.photo_url ||
                    "monogram"
                  }
                />
                <div
                  className="line-clamp-1 break-all text-[#16667A] 
                font-['Inter'] leading-[1.43] text-[14px]"
                >
                  {`${record?.first_name} ${record?.last_name}`}
                </div>
              </Link>
            </div>
          )}
        />
        <FunctionField
          label={translate("artists.role")}
          data-label={translate("artists.role") + ":"}
          render={(record: any) => (
            <p className="text-mono-primaryTextColor font-['Inter'] leading-[1.43] text-[14px]">
              {record?.role?.role || "UNVERIFIED"}
            </p>
          )}
        />
        <BooleanField
          source="artist.is_active"
          label={translate("artists.active")}
          data-label={translate("artists.active") + ":"}
          sx={{ marginTop: "6px" }}
        />
        {!isSmall && (
          <FunctionField
            render={(record: any) => (
              <div className="flex justify-end">
                <ListDotsActions>
                  <Link
                    to={
                      record?.artist?.id
                        ? `/dashboard/Artist/${record?.artist?.id}`
                        : `/dashboard/Customer/${record?.id}`
                    }
                  >
                    <ListItemButton
                      sx={{
                        fontSize: "14px",
                        fontFamily: "Inter",
                        "& .MuiListItemButton-root": {
                          fontSize: "14px",
                          fontFamily: "Inter"
                        }
                      }}
                    >
                      {translate("common.edit")}
                    </ListItemButton>
                  </Link>
                </ListDotsActions>
              </div>
            )}
          />
        )}
        {isSmall && (
          <FunctionField
            render={(record: any) => (
              <Link
                to={
                  record?.artist?.id
                    ? `/dashboard/Artist/${record?.artist?.id}/show`
                    : `/dashboard/Customer/${record?.id}/show`
                }
                style={{ width: "100%" }}
              >
                <CustomButton
                  variant="secondary"
                  text={translate("common.view_details")}
                  sx={{ width: "100%", marginBottom: "10px" }}
                />
              </Link>
            )}
          />
        )}
      </CustomDataGrid>
    </CustomList>
  );
}
